import React from "react";

export default function Modal({ open, onClose, children }) {
    if (!open) return null;
    // Handler to close when clicking overlay
    function handleOverlayClick(e) {
        if (e.target === e.currentTarget) {
            onClose && onClose();
        }
    }
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4"
            onClick={handleOverlayClick}
        >
            <div className="bg-white rounded-lg shadow-lg p-6 min-w-[320px] max-w-[90vw] max-h-[90vh] overflow-y-auto relative">
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
                    onClick={onClose}
                    aria-label="Close"
                >
                    ×
                </button>
                {children}
            </div>
        </div>
    );
}
